<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4">

    <div class="flex-0 flex flex-row items-center justify-between w-full">
        <div class="shrink-0 flex flex-row items-center justify-start gap-x-4 sm:gap-x-6">
            <button (click)="backToBriefs()" type="button" class="fab-button-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                </svg>
            </button>

            <div class="">
                <div class="inline-flex gap-x-2">
                    <h3 class="text-md font-semibold text-primary">Create Ad
                    </h3>
                </div>
                @if (createSparkCampaignService.currentSparkAdGroup()) {
                <p class="mt-0 text-xs text-secondary">{{
                    createSparkCampaignService.currentSparkAdGroup()?.adgroupName ??
                    createSparkCampaignService.currentSparkAdGroup()?.id }}</p>
                } @else {
                <p class="mt-0 text-xs text-secondary">Loading...</p>
                }

            </div>
        </div>
    </div>

    @if (ad_creation_error()) {
    <div class="h-full flex-1 flex-col items-center justify-start w-full overflow-hidden gap-y-8">
        <div class="text-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="mx-auto size-12 text-gray-400 dark:text-gray-500">
                <circle cx="12" cy="12" r="10" />
                <path d="M16 16s-1.5-2-4-2-4 2-4 2" />
                <line x1="9" x2="9.01" y1="9" y2="9" />
                <line x1="15" x2="15.01" y1="9" y2="9" />
            </svg>
            <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">Whoops!</h3>
            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">{{ ad_creation_error() }}</p>
            <div class="mt-6 flex flex-row items-center justify-center gap-x-4">
                
                <button type="button" (click)="backToBriefs()"
                    class="inline-flex items-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:shadow-none dark:hover:bg-primary/90 dark:focus-visible:outline-primary">
                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                        class="mr-1.5 -ml-0.5 size-5">
                        <path
                            d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                    </svg>
                    Exit
                </button>

                <button type="button" (click)="updateSettingsRetry()"
                    class="inline-flex items-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:shadow-none dark:hover:bg-primary/90 dark:focus-visible:outline-primary">
                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                        class="mr-1.5 -ml-0.5 size-5">
                        <path
                            d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                    </svg>
                    Update Settings
                </button>
            </div>
        </div>

    </div>
    } @else {
    <div class="h-full flex-1 flex-col items-center justify-start w-full overflow-y-auto scrollbar-transparent gap-y-8">

        <!-- Ad Name -->
        <cad-ad-name></cad-ad-name>
        <!-- Ad Name - END -->

        <!-- Ad Details -->
        <cad-ad-details></cad-ad-details>
        <!-- Ad Details - END -->

        <!-- Ad Tracking -->
        <cad-ad-tracking></cad-ad-tracking>
        <!-- Ad Tracking - END -->

    </div>


    <div
        class="flex-0 flex flex-row items-center justify-between w-full border-t border-zinc-200 dark:border-zinc-800 pt-2">
        <button (click)="backToBriefs()" type="button"
            class="secondary-button text-primary inline-flex flex-row items-center gap-x-2">
            Exit
        </button>


        <button (click)="checkAd()" type="button" class="primary-button inline-flex flex-row items-center gap-x-2">
            Continue
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
            </svg>
        </button>
    </div>
    }
</div>